import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";
import { toast } from "react-toastify";


export const useDeleteBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/brand/delete/${id}`);
      return res.data;
    },
    onSuccess: () => {
      toast.success("Brand Deleted successfully!");
      queryClient.invalidateQueries({ queryKey: ["viewBrand"] });
    },
  });
};
